var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-bubble-report-legend"},_vm._l((_vm.legendItems),function(item){return _c('div',{key:item.label,staticClass:"item"},[_c('div',{staticClass:"point",style:({ backgroundColor: item.color })}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }